export class SignalI3 {
    positionMaintenanceId: number;
    strategyFancyType: string;
    strategyFancyName: string;
    asset: string;
    sideType: number;
    strategyId: string;
    pips: number;
    entryPrice: number;
    openingTimeUtc: Date;
    closingTimeUtc: Date;
    stopLoss: number;
    takeProfit: number;
    profitPercent: number;

    constructor(payload: Partial<SignalI3>) {
        for (const key in payload) {
            this[key] = payload[key];
        }
    }

    getValue() {
        return `${this.positionMaintenanceId} | ${this.asset} | ${this.getDate()} | ${this.getSide()}`;
    }

    getSide() {
        return this.sideType === 0 ? sideTypeBuy : sideTypeSell
    }

    getDate() {
        const options: any = {
            year: 'numeric', month: 'numeric', day: 'numeric',
            hour: 'numeric', minute: 'numeric', second: 'numeric',
            hour12: false,
            timeZone: 'GMT'
        };
        return Intl.DateTimeFormat('en-US', options).format(new Date(this.openingTimeUtc));
    }
}

export const sideTypeBuy: string = 'Buy';
export const sideTypeSell: string = 'Sell';


// WEBPACK FOOTER //
// ./src/app/tradingstudio/models/SignalI3.ts